import ClipboardJS from 'clipboard'

const clipboard = new ClipboardJS('.js-clipboardButton')
const $tooltipAlert = $('.js-tooltipAlert')

clipboard.on('success', (e) => {
  $(e.trigger).addClass('is_success')

  $tooltipAlert.addClass('is_active')

  setTimeout(() => {
    $(e.trigger).removeClass('is_success')
    $tooltipAlert.removeClass('is_active')
  }, 3000)

  e.clearSelection()
})
